import { render, staticRenderFns } from "./MarkedParser.vue?vue&type=template&id=f79fd16a&"
import script from "./MarkedParser.vue?vue&type=script&lang=js&"
export * from "./MarkedParser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports